import { Label } from '@capsicum/common-web';
import { FootballIcon, ShirtIcon, SignedIcon, TimerIcon } from '@capsicum/common-web/icons';
import { AuctionAttributes, type AuctionTagsType } from '@capsicum/features/fanshop/shared';
import styled, { useTheme } from 'styled-components';

import type { CollectibleCollectibleAttributeRefined, CollectibleTag, CollectibleTagIcon } from '@capsicum/common';

export const AuctionTags = ({ auctionData, hasIcons = false, isBall = false, sortedTags }: AuctionTagsType) => {
	const { colors } = useTheme();

	const getIcon = (iconName: 'Minute' | 'Score' | CollectibleTagIcon | undefined) => {
		switch (iconName) {
			case AuctionAttributes.SIGNED:
				return SignedIcon;
			case AuctionAttributes.WORN:
				return ShirtIcon;
			case AuctionAttributes.SCORE:
				return FootballIcon;
			case AuctionAttributes.MINUTE:
				return TimerIcon;
			default:
				return undefined;
		}
	};

	return isBall
		? auctionData?.collectible?.collectibleAttributes?.map((item: CollectibleCollectibleAttributeRefined) => {
				if (
					item.attribute?.isVisible &&
					(item.attribute.name === AuctionAttributes.SCORE ||
						item.attribute.name === AuctionAttributes.MINUTE)
				) {
					return (
						<S.Tag
							$hasIcons={hasIcons}
							customColors={{
								backgroundColor:
									item.attribute.name === AuctionAttributes.SCORE
										? colors.backgrounds.status.score
										: colors.backgrounds.status.default,
								fontColor:
									item.attribute.name === AuctionAttributes.SCORE
										? colors.text.status.onAvailable
										: colors.text.status.onInfo
							}}
							icon={hasIcons ? getIcon(item.attribute.name) : undefined}
							key={item.id}
							label={`${item.value}${item.attribute.name === AuctionAttributes.MINUTE ? "'" : ''}`}
							size={hasIcons ? 'default' : 'condensed'}
						/>
					);
				}

				return null;
			})
		: sortedTags?.map(
				(tag: CollectibleTag) =>
					tag.isVisible && (
						<S.Tag
							$hasIcons={hasIcons}
							customColors={{
								backgroundColor: tag.color,
								fontColor: colors.text.status.onInfo
							}}
							icon={hasIcons ? getIcon(tag.icon) : undefined}
							key={tag.id}
							label={tag.name}
							size={hasIcons ? 'default' : 'condensed'}
						/>
					)
			);
};

namespace S {
	export const Tag = styled(Label)<{ $hasIcons?: boolean }>`
		border-top-left-radius: ${({ $hasIcons, theme }) =>
			$hasIcons ? theme.border.radius.circle['border-top-left-radius'] : 0};
		border-bottom-left-radius: ${({ $hasIcons, theme }) =>
			$hasIcons ? theme.border.radius.circle['border-bottom-left-radius'] : 0};
	`;
}
